
import React from "react";
import { EXISTING_USER_URL } from './../containers/APIurls';
import { REACT_APP_ENV } from '../containers/constants';
import { Micro } from '@vds3/typography';
import { TextLink } from '@vds3/buttons';
import cloneDeep from 'lodash/cloneDeep';

export const Privacy =()=>{
  if(new Date().getMonth() > 4){
    return(
        <div style={{margin:'10px 0'}}>
            <Micro size="small">Please see Verizon's 
            <TextLink onClick = {()=>window.open('https://www.verizon.com/about/privacy/')}> Privacy Policy</TextLink>. 
            California residents can view our 
            <TextLink onClick = {()=>window.open('https://www.verizon.com/about/privacy/full-privacy-policy?scrollto=index-1#acc-item-55')}> California Privacy Notice</TextLink>
            .</Micro>
        </div>
    )
  } else return <></>
  }
  export const isNTEenvs = () => {
    const env = REACT_APP_ENV;
    if (env && env.includes("NTE")) {
      return true;
    }
    return false;
  };
const common = {
  isValidEmail: function (emailAddress) {
    if (emailAddress) {
      const filter =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!filter.test(emailAddress)) {
        return false;
      }
    }
    return true;
  },

  isValidName: (name) => {
    // const emptyString = /^\s*$/;

    return name.match(/^[a-zA-Z0-9_-\s]{2,30}$/gm)
    // return false;
  },
  hasAlpha: (name) => {
    return /[a-z]{2}/i.test(name) || /[A-Z]{2}/i.test(name)
  }
};

export const scrollInView = (className, isTopPage = false, offset = 0) => {
  const headerHeight = 360; /* MAY NOT BE NEEDED */
  const scrollToEl = document.querySelector(className);

  let topOfElement = scrollToEl && window.pageYOffset + scrollToEl.getBoundingClientRect().top - headerHeight + offset;
  if (isTopPage) {
    topOfElement = 0;
  }
  window.scroll({ top: topOfElement || 0, behavior: "smooth" });
}

export const getNumberFromString = (value, digits=2) => {
  if (value) {
    return Number.parseFloat(value?.replace(/[^0-9.]/g,'')).toFixed(digits);
  }
  return 0;
}

export const scrollForLQInputErrors = (className) => {
  const header = document.querySelector(".global-header");
  const headerHeight = header.scrollHeight + 20;

  const element = document.querySelector(className);
  const scrollUpToThis = element?.offsetTop - headerHeight;

  window.scroll(0,scrollUpToThis || 0);
}

export const scrollRefInView = (ref, isTopPage = false) => {
  // const headerHeight = 360;
  const headerHeight = 300;

  let topOfElement = ref?.current?.offsetTop - headerHeight;
  if (isTopPage) {
    topOfElement = 0;
  }
  window.scroll({ top: topOfElement || 0, behavior: "smooth" });
  // Internet Explorer 6-11
  const isIE = /*@cc_on!@*/false || !!document.documentMode;
  // Edge 20+
  const isEdge = !isIE && !!window.StyleMedia;
  if(isIE || isEdge ) {window.scroll(0, topOfElement || 0);}
}

export const scrollRefInView2 = (ref, isTopPage = false) => {

  let topOfElement = ref?.current?.offsetTop;
  if (isTopPage) {
    topOfElement = 0;
  }
  window.scroll({ top: topOfElement || 0, behavior: "smooth" });
  // Internet Explorer 6-11
  const isIE = /*@cc_on!@*/false || !!document.documentMode;
  // Edge 20+
  const isEdge = !isIE && !!window.StyleMedia;
  if(isIE || isEdge ) {window.scroll(0, topOfElement || 0 );}
}

export const isNumeric = (e) => {

  const keyCode = (e.which) ? e.which : e.keyCode;
  if (e.ctrlKey || e.altKey || (47 < keyCode && keyCode < 58 && e.shiftKey === false) 
    || (95 < keyCode && keyCode < 106) || (keyCode === 8) || (keyCode === 9) 
    || (keyCode > 34 && keyCode < 40) || (keyCode === 46) ) {
      return true;
  }
  else {
      e.preventDefault();
  }
}

export const isAlpha = (e) => {
  const pattern = /^[a-zA-Z ]*$/;
  if ((e.key).match(pattern)) {
      return true;
  }
  else {
      e.preventDefault();
  }
}
export const allowNumberAndAlphabet = (e) => {
  const pattern = /^[a-z A-Z 0-9]*$/ ;
  if ((e.key).match(pattern)) {
    return true;
}
else {
  e.preventDefault();
}
}

/** For Chat Refresh On URL Change */
export const refreshChatHashTag = () =>{
  if(window && window.refreshChatHashTag) {
     window.refreshChatHashTag();
  }
}

export const LPSavedCartOfferEngagement = (arg) =>{
  try {
    if (window && window.LPSavedCartOfferEngagement) {
      window.LPSavedCartOfferEngagement(arg);
    }
  } catch (e) {
    console.error(e);
  }
}

export const LPErrorEngagement = (arg) =>{
  try {
    if (window && window.LPErrorEngagement) {
      window.LPErrorEngagement(arg);
    }
  } catch (e) {
    console.error(e);
  }
}

export const setChatInfo = (res) =>{
  if(res && window.setCustomerInfo) {
  window.setCustomerInfo('ZIP_CODE', res.Zip);
  window.setCustomerInfo('DOTCOM_SESSIONID', res.GuiSessionId);
  window.setCustomerInfo('STATE', res.State);
  window.setCustomerInfo('other', res.AimsFlow);
  window.setCustomerInfo('BundleCode', res.ActualBundleCode);
  window.setCustomerInfo('aimsChatCreditFlow', res.AimsChatCreditFlow);
  window.setCustomerInfo('NEW_CONNECT', res.AppID);
  window.setCustomerInfo('WINBACK', res.Winback);
  window.setCustomerInfo('CRV_NUMBER', res.Cvcnumber);
  window.setCustomerInfo('ONE_TIME_FEE', res.Onetimefee);
  window.setCustomerInfo('ORDER_TOTAL', res.Ordertotal);
  window.setCustomerInfo('ORDER_NUMBER', res.Ordernumber);
  window.setCustomerInfo('ACCOUNT_NUMBER', res.Accountnumber);
  window.setCustomerInfo('NAME', res.ActualName);
  window.setCustomerInfo('EMAIL', res.ActualEmail);
  window.setCustomerInfo('PRODUCT_DETAILS', res.Productdetails);
  window.setCustomerInfo('FIOS', res.Fios);
  window.setCustomerInfo('product code', res.productCode);
  window.setCustomerInfo('mon', res.Ordernumber);
  window.setCustomerInfo('Registration_Key', res.GuiSessionId);
  window.setCustomerInfo('Customet_BAN', res.BAN);
  window.setCustomerInfo('Customer_CAN', res.PCAN);
  window.setCustomerInfo('Customer_PCAN', res.PCAN);
  window.setCustomerInfo('Customer_BillingAddress', res.BillingAddress);
  window.setCustomerInfo('Customer_ServiceAddress', res.ServiceAddress);
  window.setCustomerInfo('Customer_BTN', res.BTN);
  window.setCustomerInfo('SourcePage','Simplified_Ordering');
  window.setCustomerInfo('globalSessionId',res.GlobalSessionID);
  window.setCustomerInfo('APPLICABLE_SERVICES',res.ApplicableServices);
}
}


/* MOVE IT OUT OF COMMON */
export const handleSignInClickEvent = () => {
/*
  // window.top.location = GB_SIGN_IN_URL;
 const hostName = window.top.location.hostname;

  if(hostName.indexOf("www.verizon.com") > -1) {
    window.top.location = SIGN_IN_PROD_URL;
  } else {
    window.top.location = SIGN_IN_SIT_URL;
  }*/
  window.location.href=EXISTING_USER_URL;
}

export const loadScript = (execScript) => {
  const script = document.createElement('script');
  script.innerHTML = execScript;
  document.head.appendChild(script);
}

export const loadJQueryIfNotAvailable = () => {
  if (window.jQuery && !window.$ && window.initializeJQuery) {
    window.initializeJQuery();
  } else if (window.loadJQueryIfNotAvailable) {
    window.loadJQueryIfNotAvailable();
  }
}

export const isNightTimeWindow = () => {
  const startTime = '22:00:00';
  const endTime = '06:00:00';

 const currentDate = new Date()   

  const startDate = new Date(currentDate.getTime());
  startDate.setHours(startTime.split(":")[0]);
  startDate.setMinutes(startTime.split(":")[1]);
  startDate.setSeconds(startTime.split(":")[2]);

  const endDate = new Date((new Date().getTime() + 24 * 60 * 60 * 1000));
  endDate.setHours(endTime.split(":")[0]);
  endDate.setMinutes(endTime.split(":")[1]);
  endDate.setSeconds(endTime.split(":")[2]);

 return startDate < currentDate && endDate > currentDate

}

export const getCookieByName = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts?.length === 2) return parts?.pop().split(';').shift();
}


export const isIEBrowser = () => {
  const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
  const msie = ua.indexOf('MSIE '); // IE 10 or older
  const trident = ua.indexOf('Trident/'); //IE 11
  
  return (msie > 0 || trident > 0);
}

export const capitalizeFirstLetter = (string) => {
  if(string === 'tv')
  return String(string).toUpperCase()
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const filterUniqueUnits = (unitList) => {
  const seen = new Set();
  let filteredList = unitList.filter(item => {
    const key = (item?.unit || "").trim().toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  return filteredList;
};

export const addUnitOptions = (unitList = [], selectedStreetAddress,unitSuggestionAem,showUnitSuggestions=false) => {
  if(!showUnitSuggestions) {
    return unitList;
  }else{
  if (selectedStreetAddress?.addressClassification?.toUpperCase() !== "MDU") {
    return unitList;
  }
  let formattedUnitList = cloneDeep(unitList);
  if(unitSuggestionAem && Array.isArray(unitSuggestionAem) && unitSuggestionAem?.length > 0){
    unitSuggestionAem.forEach((unit) => {
      if (!formattedUnitList.some((data) => data?.unit?.toLowerCase() === unit?.toLowerCase())) {
        if(unit === "I don't live in a unit" || unit === "I don't have a unit") {
          formattedUnitList.unshift({ baseAddressId: selectedStreetAddress?.baseAddressId || "", addressId: "", unit: unit });
        }else {
          formattedUnitList.push({ baseAddressId: selectedStreetAddress?.baseAddressId || "", addressId: "", unit: unit });
        }
      }
    });
  } else {
  const hasUnit = (text) =>
    formattedUnitList.some((data) => data?.unit?.toLowerCase() === text.toLowerCase());

  if (!hasUnit("I don't live in a unit")) {
    formattedUnitList.unshift({ baseAddressId: selectedStreetAddress?.baseAddressId || "", addressId: "", unit: "I don't live in a unit" });
  }
  if (!hasUnit("I don't have a unit")) {
    formattedUnitList.unshift({ baseAddressId: selectedStreetAddress?.baseAddressId || "", addressId: "", unit: "I don't have a unit" });
  }
  if (!hasUnit("I don't see my unit")) {
    formattedUnitList.push({ baseAddressId: selectedStreetAddress?.baseAddressId || "", addressId: "", unit: "I don't see my unit" });
  }
  if (!hasUnit("I can't find my unit")) {
    formattedUnitList.push({ baseAddressId: selectedStreetAddress?.baseAddressId || "", addressId: "", unit: "I can't find my unit" });
  }
  formattedUnitList = filterUniqueUnits(formattedUnitList);
  return formattedUnitList;
}
}
};

export default common;
